(function (ws) {
    'use strict';

    ws.views.VatTool = Backbone.View.extend({

        events: {
            'click .invoiceCountryBtn': 'openInvoiceCountryModal',
            'click .shipHelpbtn': 'openShipFromModal',
            'click .defaultValuedecorator': 'openDefaultValueModal',
            'change #tangiblePrd': 'toggleVndorDropshop',
            'change #intangiblePrd': 'toggleLocallyProcured',
            'change #vendordrpshop': 'toggleVendorDropshop',
            'change #locallyProcured': 'toggleDeliverProcFn',
            'click .vatToolOk': 'showVatResultContainer',
            'change .shipTodec': 'showCheckBoxAndDropDown'
        },

        initialize: function () {
            this.$('select').select2({
                dropdownAutoWidth: true,
                width: '100%',
                dropdownCssClass: 'vatTooldrpdwn'
            });

            this.eventAgg.on('shipToVat', this.openShipTovatModal.bind(this));
            this.eventAgg.on('invoiceCountryHelpModalOpen', this.invoiceCountryHelpModal.bind(this));
        },

        openInvoiceCountryModal: function() {
            this.eventAgg.trigger('invoiceCountryHelpModal');

            // if ($('.shipTodec').val() !== '') {
            //     $('.customerPayerVatReg').removeClass('hide');
            //     let dynamicCntryTxt = $('.shipTodec option:selected').html();
            //     $('.dynamicCountryText').html(dynamicCntryTxt);
            // } else {
            //     $('.customerPayerVatReg').addClass('hide');
            // }
        },

        openShipFromModal: function() {
            this.eventAgg.trigger('shipFromHelpModal');
        },

        openDefaultValueModal: function() {
            this.eventAgg.trigger('defaultValueVar');
        },

        openShipTovatModal: function() {
            this.eventAgg.trigger('shipToVatModal');
        },

        invoiceCountryHelpModal: function() {
            this.eventAgg.trigger('invoiceCountryHelpModal');
        },

        toggleVndorDropshop: function(e) {
            $('#vendordrpshop').prop('checked', false);
            if ($('#intangiblePrd').prop('checked') && $(e.target).prop('checked') && !$('#locallyProcured').prop('checked')) {
                $('.vndrDrpContainer, .supplyChainContainer, .plantContainer, .shipToContainer, .customerSalesContainer, .invoiceCountry, .salesOffice, .custVATRegDec, .invoiceCountryBtnDec').removeClass('hide');
                $('.errorMsgVATDec').addClass('hide');
            } else if ($('#intangiblePrd').prop('checked') && $(e.target).prop('checked') && $('#locallyProcured').prop('checked')) {
                $('.vndrDrpContainer, .supplyChainContainer, .plantContainer, .shipToContainer, .customerSalesContainer, .invoiceCountry, .salesOffice, .custVATRegDec, .invoiceCountryBtnDec').removeClass('hide');
                $('.errorMsgVATDec').removeClass('hide');
            } else if ($('#intangiblePrd').prop('checked')) {
                $('.supplyChainContainer, .plantContainer, .customerSalesContainer, .invoiceCountry, .salesOffice, .custVATRegDec').removeClass('hide');
                $('.errorMsgVATDec').addClass('hide');
                $('.vndrDrpContainer, .shipToContainer, .invoiceCountryBtnDec, .shipFromContainer, .shipFromHelpDec').addClass('hide');
            } else {
                $('.errorMsgVATDec').addClass('hide');
                $('.vndrDrpContainer').toggleClass('hide');
                $('.supplyChainContainer').toggleClass('hide');
                $('.plantContainer').toggleClass('hide');
                $('.shipToContainer').toggleClass('hide');
                $('.customerSalesContainer').toggleClass('hide');
                $('.invoiceCountry').toggleClass('hide');
                $('.salesOffice').toggleClass('hide');
                $('.custVATRegDec').toggleClass('hide');
                $('.invoiceCountryBtnDec').toggleClass('hide');
            }

        },

        toggleLocallyProcured: function(e) {
            $('#locallyProcured').prop('checked', false);
            if ($('#tangiblePrd').prop('checked') && $(e.target).prop('checked')) {
                $('.lclyPrcrd, .supplyChainContainer, .plantContainer, .customerSalesContainer, .invoiceCountry, .salesOffice, .custVATRegDec').removeClass('hide');
                $('.errorMsgVATDec').addClass('hide');
            } else if ($('#tangiblePrd').prop('checked') && $(e.target).prop('checked') && $('#locallyProcured').prop('checked')) {
                $('.errorMsgVATDec').removeClass('hide');
            } else if ($('#tangiblePrd').prop('checked')) {
                $('.supplyChainContainer, .plantContainer, .customerSalesContainer, .invoiceCountry, .salesOffice, .custVATRegDec').removeClass('hide');
                $('.errorMsgVATDec').addClass('hide');
                $('.lclyPrcrd, .deliverInContainer, .ProcureFromContainer').addClass('hide');
            } else {
                $('.errorMsgVATDec').addClass('hide');
                $('.lclyPrcrd').toggleClass('hide');
                $('.supplyChainContainer').toggleClass('hide');
                $('.plantContainer').toggleClass('hide');
                $('.customerSalesContainer').toggleClass('hide');
                $('.invoiceCountry').toggleClass('hide');
                $('.salesOffice').toggleClass('hide');
                $('.custVATRegDec').toggleClass('hide');
            }
        },

        toggleVendorDropshop: function() {
            $('.shipFromContainer').toggleClass('hide');
            $('.shipFromHelpDec').toggleClass('hide');
        },

        toggleDeliverProcFn: function(e) {
            if ($('#tangiblePrd').prop('checked') && $(e.target).prop('checked')) {
                $('.errorMsgVATDec').removeClass('hide');
                $('.deliverInContainer').toggleClass('hide');
                $('.ProcureFromContainer').toggleClass('hide');
            } else if ($('#tangiblePrd').prop('checked') && !$(e.target).prop('checked')) {
                $('.errorMsgVATDec').addClass('hide');
                $('.deliverInContainer').toggleClass('hide');
                $('.ProcureFromContainer').toggleClass('hide');
            } else {
                $('.deliverInContainer').toggleClass('hide');
                $('.ProcureFromContainer').toggleClass('hide');
                $('.errorMsgVATDec').addClass('hide');
            }

        },

        showVatResultContainer: function() {
            $('.vatResultContainer').removeClass('hide');
            $('.vatSetupContainer').removeClass('large-12').addClass('large-6');

            $('.comp-vattool select').each(function() {
                if ($(this).is(':visible') && $(this).attr('required') && !$(this).val()) {
                    $(this).siblings('.select2-container').addClass('required-border-error');
                }
            });
        },

        showCheckBoxAndDropDown: function(e) {
            let shipToVar = $(e.target).val();
            if (shipToVar === 'NO' || shipToVar === 'CH') {
                $('.isIorContainer').removeClass('hide');
            } else {
                $('.isIorContainer').addClass('hide');
            }

            if (shipToVar === 'ES'  || shipToVar === 'FR' || shipToVar === 'GB') {
                $('.shipToZoneContainer').removeClass('hide');
            } else {
                $('.shipToZoneContainer').addClass('hide');
            }
        }
    });
})(westcon);
